// extracted by mini-css-extract-plugin
module.exports = {"newsItemContainer":"ReadMore_newsItemContainer__1C4VK","newsItemContainerHorizontal":"ReadMore_newsItemContainerHorizontal__3NPbp"};